import React, { FC } from "react";
import style from "./style.module.scss";
import arrowBackBlack from "../../assets/images/arrowBackBlack.svg";
import { Title } from "..";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store";
import appConfig from "../../util/appConfig";

interface ITitleComponent {
  title: string;
  marginBottom?: string;
  titleWidthContainer?: string;
  withoutBackButton?: boolean;
}

export const TitleComponent: FC<ITitleComponent> = ({
  title,
  marginBottom,
  titleWidthContainer,
  withoutBackButton = false,
}) => {
  const navigate = useNavigate();
  const { isMobile } = useAppSelector((state) => state.app.client);

  const backBtnHandler = () => {
    if (["lra"].includes(appConfig.logo)) {
      navigate("/#alle-online-dienste");
      return;
    }
    navigate(-1);
  };

  return (
    <div
      className={style.wrapper}
      style={{
        marginBottom: marginBottom ? `${marginBottom}px` : "",
      }}
    >
      <div
        style={{
          width: titleWidthContainer ? `${titleWidthContainer}px` : "",
          margin: titleWidthContainer ? "0 auto" : "",
          textTransform: "uppercase",
        }}
      >
        <Title
          title={title}
          fontSize="24"
          letterSpacing="1px"
          mobileFontSize="20"
          hasHelperPadding={true}
          isMainTitle
        />
      </div>
      {withoutBackButton ? null : (
        <div
          className={style.back}
          onClick={backBtnHandler}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              backBtnHandler();
            }
          }}
        >
          <img src={arrowBackBlack} alt="Zurück zur vorherigen Seite" />
          {!isMobile && <span>Zurück</span>}
        </div>
      )}
    </div>
  );
};
